<template>
  <div>
    <div v-if="!isContactFormVisible">
    <d-card-header class="border-bottom flex-header">
      <h6 class="m-0">Historia kontaktu</h6>
      <ss-popover
        v-if="scheduleFinished"
        variant="left">
        <d-button
          class="disabled is-disabled"
          theme="success">
          <i class="material-icons">add</i> Dodaj kontakt
        </d-button>
        <template slot="tooltip">
          Po zamknięciu umowy nie ma możliwości dodania kontaktu
        </template>
      </ss-popover>
      <d-button
        v-else @click.prevent="showContactForm(null)"
        theme="success">
        <i class="material-icons">add</i> Dodaj kontakt
      </d-button>
    </d-card-header>

    <contacts-history
      :props="contactHistory"
      :finished="scheduleFinished"
      @editContact="showContactForm"
      @removeContact="removeContactHandler" />
    </div>

    <d-form
      v-if="isContactFormVisible"
      @keyup.enter="saveContact" >
      <d-card-header class="border-bottom flex-header">
        <h6 class="m-0">
          <template v-if="!selectedContact.id">
            Nowy kontakt
          </template>
          <template v-else>
            Edycja kontaktu {{ selectedContact.created_at }}
          </template>
        </h6>
        <d-button @click.prevent="isContactFormVisible = false">
          <i class="material-icons">close</i> Zamknij
        </d-button>
        <d-button
          @click.prevent="saveContact"
          theme="success">
          <i class="material-icons">save</i> Zapisz
        </d-button>
      </d-card-header>

      <contact :props.sync="selectedContact" />
    </d-form>
  </div>
</template>

<script>
import ClientUtils from '@/utils/client';
import LarErrors from '@/helpers/Errors';
import ContactsHistory from '@/components/client/ContactsHistory.vue';
import Contact from '@/components/client/Contact.vue';

export default {
  name: 'ContractContactHistoryTab',
  components: {
    LarErrors,
    ContactsHistory,
    Contact
  },
  props: {
    contactHistory: {
      default: () => [],
      type: Array
    },
    scheduleFinished: {
      default: false,
      type: Boolean
    },
    scheduleId: {
      required: true,
      type: Number
    },
    clientId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      actionInProgress: false,
      isContactFormVisible: false,
      selectedContact: null
    }
  },
  methods: {
    showContactForm (contactToEdit = null) {
      if (contactToEdit) {
        this.selectedContact = JSON.parse(JSON.stringify(contactToEdit));
      } else {
        this.selectedContact = JSON.parse(JSON.stringify(ClientUtils._contact));
      }

      this.$nextTick(() => {
        this.isContactFormVisible = true;
      })
    },
    removeContactHandler () {
      this.$bus.$emit('contract-reload-contact-history');
      this.$bus.$emit('reload-contract');
    },
    saveContact () {
      let dataToSave = new FormData();
      let __contact = JSON.parse(JSON.stringify(this.selectedContact));
      __contact.schedule_id = this.scheduleId;
      __contact.client_id = this.clientId || null;
      __contact.files = this.selectedContact.files.reduce((filtered, option) => {
        if (option.file) {
          filtered.push(option.file);
        }
        return filtered;
      }, []);
      Vue.appendFormdata(dataToSave, __contact);

      this.actionInProgress = true;
      axios.post('api/contact-history/save-client-history', dataToSave).then(response => {
        Vue.swal({
          type: 'success',
          title: 'Kontakt został zapisany.',
          showConfirmButton: true,
        }).then(() => {
          this.isContactFormVisible = false;
          this.$bus.$emit('contract-reload-contact-history');
          this.$bus.$emit('reload-contract');
        });
        this.actionInProgress = false;
      }).catch((error) => {
        this.actionInProgress = false;
        console.log(error);
        LarErrors.record(error.response.data.errors)
      })
    },
  }
}
</script>
